// Utilities
import { createSimpleFunctional } from "../../util/index.mjs";
export const VListItemTitle = createSimpleFunctional('v-list-item-title');
//# sourceMappingURL=VListItemTitle.mjs.map